// extracted by mini-css-extract-plugin
module.exports = {"noTabs":"AlertDropdown_noTabs__3X8VX","link":"AlertDropdown_link__AXxCd"};